import ReactMarkdown from "react-markdown";
import styled from "styled-components";

export const Markdown = styled(ReactMarkdown)`
  align-items: start !important;

  * {
    text-align: start !important;
  }

  h1 {
    font-size: 32px;
    font-weight: 700;
  }
  h2 {
    font-size: 26px;
    font-weight: 700;
  }
  table {
    margin: 15px 0;
  }
  td,
  th {
    border: 1px solid #c1c1c1;
    padding: 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 0.7rem;
  }
  p > code {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #c1c1c1;
  }
  ul {
    list-style: disc;
    padding: 0 0 0 20px;
    margin: 10px 0;
  }
  a {
    color: #00abab;
  }
  blockquote {
    border-left: 5px solid #dbdbdb;
    padding: 10px;
    margin: 15px 0px;
  }
`;
